import React from 'react';
import ErrorMsg from '../components/ErrorMsg';

const Renaming = ({
  renaming,
  index,
  onRenaming,
  onFocus,
  onBlur
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group col mb-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "mb-1 fs-sm",
    htmlFor: "renaming-" + index
  }, "Renaming"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `form-control form-control-sm ${renaming.error ? "is-invalid" : ""}`,
    id: "renaming-" + index,
    onChange: e => onRenaming(e.target.value),
    onBlur: e => onBlur(e.target.value),
    onFocus: e => onFocus(e.target.value),
    value: renaming.input
  }), /*#__PURE__*/React.createElement(ErrorMsg, {
    error: renaming.error,
    input: renaming.input
  }));
};

export default Renaming;